export const DEFAULT_REPLY_LOCALE = 'zh-TW';

export const parseBrowserLanguages = (browserLanguages?: string | string[] | null) => {
	if (Array.isArray(browserLanguages)) {
		return browserLanguages.map(language => language.trim()).filter(Boolean);
	}

	if (!browserLanguages) {
		return [];
	}

	return browserLanguages
		.split(',')
		.map(language => language.trim())
		.filter(Boolean);
};

const isChineseLocale = (locale: string) => locale === 'zh' || locale.startsWith('zh-');

const isEnglishLocale = (locale: string) => locale === 'en' || locale.startsWith('en-');

const isBahasaLocale = (locale: string) => locale === 'id' || locale.startsWith('id-');

const isVietnameseLocale = (locale: string) => locale === 'vi' || locale.startsWith('vi-');

const isTagalogLocale = (locale: string) =>
	locale === 'tl' || locale.startsWith('tl-') || locale === 'fil' || locale.startsWith('fil-');

const isThaiLocale = (locale: string) => locale === 'th' || locale.startsWith('th-');

const isSupportedLocale = (locale?: string | null) => {
	const normalizedLocale = locale?.trim().toLowerCase();

	if (!normalizedLocale) {
		return false;
	}

	return (
		isChineseLocale(normalizedLocale) ||
		isEnglishLocale(normalizedLocale) ||
		isBahasaLocale(normalizedLocale) ||
		isVietnameseLocale(normalizedLocale) ||
		isTagalogLocale(normalizedLocale) ||
		isThaiLocale(normalizedLocale)
	);
};

export const normalizeReplyLocale = (locale?: string | null) => {
	const normalizedLocale = locale?.trim().toLowerCase();

	if (!normalizedLocale) {
		return DEFAULT_REPLY_LOCALE;
	}

	if (isChineseLocale(normalizedLocale)) {
		return 'zh-TW';
	}

	if (isEnglishLocale(normalizedLocale)) {
		return 'en-US';
	}

	if (isBahasaLocale(normalizedLocale)) {
		return 'id-ID';
	}

	if (isVietnameseLocale(normalizedLocale)) {
		return 'vi-VN';
	}

	if (isTagalogLocale(normalizedLocale)) {
		return 'tl-PH';
	}

	if (isThaiLocale(normalizedLocale)) {
		return 'th-TH';
	}

	return DEFAULT_REPLY_LOCALE;
};

export const resolveReplyLocale = (language?: string | null, languages: string[] = []) => {
	const localeCandidates = [language, ...languages].filter((locale): locale is string => Boolean(locale));
	const matchedLocale = localeCandidates.find(locale => isSupportedLocale(locale));

	return normalizeReplyLocale(matchedLocale);
};

export const attachReplyLocale = (messageObject: any, replyLocale: string) => ({
	...messageObject,
	data: {
		...(messageObject?.data || {}),
		replyLocale: normalizeReplyLocale(replyLocale),
	},
});
